import { getSpriteUrl } from '../../getSpriteUrl';
import type { WalletBookSchema } from '../../legacyWalletBook.types';
import { getChainFromWalletSchema } from '../getChainFromWalletSchema';
import type { WalletConnectCatalogWallet } from '../getWalletConnectCatalog.types';

type TransformWalletParams = {
  wallet: WalletBookSchema['wallets'][string];
  walletKey: string;
};

/**
 * Transforms a wallet schema into a WalletConnect catalog wallet entry.
 */
export const transformWallet = ({
  wallet,
  walletKey,
}: TransformWalletParams): WalletConnectCatalogWallet => {
  const spriteId = wallet.brand?.spriteId ?? '';

  const androidId = wallet.mobile?.androidId;
  const iosId = wallet.mobile?.iosId;

  return {
    chain: getChainFromWalletSchema({ wallet, walletKey }),
    deeplinks: {
      native: wallet.mobile?.native,
      universal: wallet.mobile?.universal,
    },
    downloadLinks: {
      androidUrl: androidId
        ? `https://play.google.com/store/apps/details?id=${androidId}`
        : undefined,
      iosUrl: iosId ? `https://apps.apple.com/app/${iosId}` : undefined,
    },
    groupId: wallet.group,
    name: wallet.name,
    primaryColor: wallet.brand?.primaryColor,
    spriteUrl: spriteId ? getSpriteUrl({ spriteId }) : '',
  };
};
